@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    display: grid;
    grid-template-columns: 1fr 1fr;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr;
    }

    & .featureImg {
        display: block;
        max-width: 100%;
        object-fit: contain;
    }

    & .featureText {
        align-items: center;
        display: flex;
    }

    & .links {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 1em;

        &.alignLeft {
            flex-direction: row;
        }

        &.alignRight {
            flex-direction: row-reverse;
        }

        &.alignCenter {
            flex-direction: center;
        }
    }
}

.mediaCaption {
    font-size: 1.125rem;
    margin: 1.25rem auto;
    max-width: 21.1875rem;
    text-align: center;
}

.featureMedia {
    display: flex;
    flex-wrap: wrap;
}

.alignMediaLeft {
    justify-content: flex-start;
}

.alignMediaCenter {
    justify-content: center;
}

.alignMediaRight {
    justify-content: flex-end;
}

.mediaRight {
    & .featureMedia {
        @include breakpoint.breakpoint(layout.$aboveMedium) {
            order: 1;
        }
    }
}
